import { useQuery } from '@tanstack/react-query';
import { useApi } from './client.js';

export interface AuditEvent {
  id: string;
  userId: string | null;
  action: string;
  artifactType: string | null;
  artifactId: string | null;
  outcome: 'success' | 'failure' | 'denied';
  correlationId: string;
  occurredAt: string;
  details: Record<string, unknown>;
}

export interface AuditSummary {
  windowHours: number;
  actions: Array<{ action: string; count: number }>;
}

export interface AuditFilters {
  action?: string;
  actionPrefix?: string;
  artifactType?: string;
  outcome?: string;
  limit?: number;
}

export function useAuditEvents(filters: AuditFilters = {}) {
  const api = useApi();
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== '' && v !== null) params.set(k, String(v));
  }
  const qs = params.toString();
  return useQuery<AuditEvent[]>({
    queryKey: ['audit-events', filters],
    queryFn: () => api.fetch(`/audit/events${qs ? `?${qs}` : ''}`),
    refetchInterval: 8_000,
  });
}

export function useAuditSummary(hours = 24) {
  const api = useApi();
  return useQuery<AuditSummary>({
    queryKey: ['audit-summary', hours],
    queryFn: () => api.fetch(`/audit/summary?hours=${hours}`),
    refetchInterval: 15_000,
  });
}
